import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../common/Button/Button';
import Icon from '../../common/Icon/Icon';
import Navbar from '../Navbar/Navbar';
import LanguageSwitcher from '../LanguageSwitcher';
import { useLanguage } from '../../../context/LanguageContext';
function MobileMenu({ isOpen, onClose }) {
  const { translate } = useLanguage();
  const closeRef = useRef(null);
  useEffect(() => {
    if (!isOpen) return undefined;
    const handleEscape = (event) => { if (event.key === 'Escape') onClose(); };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleEscape);
    closeRef.current?.focus();
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="mobile-menu" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }} role="presentation"><aside aria-label={translate('Mobile navigation')} className="mobile-menu__panel" id="mobile-navigation"><div className="mobile-menu__header"><strong>{translate('Menu')}</strong><Button ref={closeRef} aria-label={translate('Close menu')} onClick={onClose} variant="text"><Icon name="close" /></Button></div><div className="mobile-menu__language"><LanguageSwitcher /></div><Navbar onNavigate={onClose} /><div className="mobile-menu__account"><Link onClick={onClose} to="/account">{translate('Customer Account')}</Link><Link onClick={onClose} to="/register">{translate('Create Account')}</Link></div></aside></div>;
}
export default MobileMenu;
